<template>
  <b-modal
    id="modal-confirmacao-reprocessamento"
    ref="modal"
    title="Confirmação"
    size="md"
    centered
    hide-footer
    @hidden="onModalClosed"
  >
    <div class="text-center">
      <p class="mb-2">
        Deseja reprocessar este registro? <br /> O sistema tentará reenviar para a RNDS utilizando as regras e validações atuais.
      </p>
      
      <div class="d-flex justify-content-center">
        <b-button
          variant="secondary-button"
          class="mr-2 px-4"
          @click="cancelar"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          class="px-4"
          @click="confirmar"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          {{ loading ? 'Reprocessando...' : 'Reprocessar' }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from 'bootstrap-vue';

export default {
  name: 'ConfirmacaoReprocessamentoModal',
  
  components: {
    BModal,
    BButton,
    BSpinner
  },
  
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    show() {
      this.$bvModal.show('modal-confirmacao-reprocessamento');
    },
    
    hide() {
      this.$bvModal.hide('modal-confirmacao-reprocessamento');
    },
    
    cancelar() {
      this.$emit('cancelar');
      this.hide();
    },
    
    confirmar() {
      this.$emit('confirmar');
    },
    
    onModalClosed() {
      this.$emit('closed');
    }
  }
}
</script>

<style scoped>
.btn {
  min-width: 120px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.btn-primary-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.btn-primary-button:hover:not(:disabled) {
  background-color: #0056b3;
  border-color: #0056b3;
  transform: translateY(-1px);
}

.btn-secondary-button {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn-secondary-button:hover:not(:disabled) {
  background-color: #545b62;
  border-color: #545b62;
  transform: translateY(-1px);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
